// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"553":"9a0cd974","977":"3a8e793c"}[chunkId] + ".chunk.js");